import { Zap } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/site";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative py-7 border-y border-white/10 bg-[#04120E] overflow-hidden" data-testid="benefits-marquee" aria-hidden="true">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-10">
            <span className="font-heading text-lg sm:text-xl font-semibold tracking-wide text-emerald-100/35 uppercase">
              {item}
            </span>
            <Zap size={14} className="text-[#00E676]/50 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
